<script setup lang="ts">
import { provide, readonly, ref, watch, watchEffect } from "vue";
import { RouterView, useRoute } from "vue-router";

import ModalDialog from "@/components/ui/ModalDialog.vue";
import ToastNotificationArea from "@/components/ui/ToastNotificationArea.vue";
import { lastErrorKey, raiseErrorKey, type ErrorCode } from "@/injectionKeys";
import * as tracking from "@/services/tracking";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const auth = useAuthStore();

const lastError = ref<ErrorCode>();

function raiseError(code: ErrorCode) {
  lastError.value = code;
}

watch(
  () => route.fullPath,
  () => {
    lastError.value = undefined;
  }
);

watchEffect(() => {
  if (auth.isAuthenticated && auth.currentUser !== null) {
    tracking.identifyUser(auth.currentUser);
  }
});

provide(raiseErrorKey, raiseError);
provide(lastErrorKey, readonly(lastError));
</script>

<template>
  <div class="app-content">
    <div class="app-shell">
      <RouterView />
    </div>
    <ToastNotificationArea />
    <ModalDialog />
  </div>
</template>

<style scoped>
.app-content {
  color: var(--content-primary);
}
</style>
